<app-signup (renderConfirmationEvent)="renderConfirmation()" *ngIf="!shouldRenderConfirmation"></app-signup>

<div class="container mb-5 mt-5" *ngIf="shouldRenderConfirmation">
    <!-- HEADER -->
    <div class="row mb-3">
        <div class="col-12">
            <h1 class="text-dark font-weight-bold text-left mb-2">Your account has been created with success!</h1>
            <h4 class="text-muted text-left">Thank you for choosing pulsyai.</h4>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <p  style="font-size: large;">Please confirm your account via the email you will receive shortly.</p>
        </div>

        <div class="col-12 mt-2">
            <button mat-raised-button color="primary" [routerLink]="loginPath">Login</button>
        </div>
    </div>

</div>